module.exports = __webpack_public_path__ + "fonts/8e99e329c4747be10a98abcce64b457d.svg";